import { render } from "./AuthorNamesLine.vue?vue&type=template&id=0f2c194e"
import script from "./AuthorNamesLine.vue?vue&type=script&lang=js"
export * from "./AuthorNamesLine.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__